import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import i18n from './language';
import less from 'less'
import uploader from 'vue-simple-uploader'
import GeminiScrollbar from 'vue-gemini-scrollbar'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/common/moniter'
Vue.use(GeminiScrollbar)
Vue.use(uploader)
Vue.use(less)
Vue.use(ViewUI);
Vue.use(ElementUI);
Vue.config.productionTip = false
new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
